/* unplugin-vue-components disabled */import { render } from "./SpeachSearchResult.vue?vue&type=template&id=1e498d7a&scoped=true&ts=true"
import script from "./SpeachSearchResult.vue?vue&type=script&lang=ts"
export * from "./SpeachSearchResult.vue?vue&type=script&lang=ts"

import "./SpeachSearchResult.vue?vue&type=style&index=0&id=1e498d7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e498d7a"]])

export default __exports__